import { CommonList } from './CommonList';
import { VerticalNavModel } from './VerticalNavModel';

export abstract class Extension<T extends string> {
  protected value: T;

  constructor(value: T) {
    if (!value) throw new Error('Without Enum value extension not be created');
    this.value = value;
  }

  public get id(): string {
    return this.value;
  }

  public abstract get label(): string;

  public toList(): CommonList {
    return new CommonList(this.label, this.id);
  }

  public toNavList(): VerticalNavModel {
    return VerticalNavModel.create(this.label, this.id);
  }
}
